module.exports = __webpack_public_path__ + "img/niño64.01230f29.jpg";